/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-lines-per-function */
import React, { useEffect } from 'react'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'
import WorkScheduleLogTable from '~/features/Audit/components/WorkScheduleLog'

export default function ScaleAuditPage() {
  const { translate } = useLang()

  useEffect(() => {
    document.title = translate('Scale Audit - Dispatch System')
  }, [])

  return (
    <Layout marginLayout={true}>
      <WorkScheduleLogTable />
    </Layout>
  )
}

